import React from 'react';

const ModulePageHeader = ({ icon: Icon, title, subtitle, iconBg }) => (
  <div className="module-header">
    <div className="module-header__icon" style={{ background: iconBg }}>
      {Icon ? <Icon className="w-6 h-6" /> : null}
    </div>
    <div>
      <h1>{title}</h1>
      {subtitle ? <p className="module-header__subtitle">{subtitle}</p> : null}
    </div>
  </div>
);

export default ModulePageHeader;
